import { Button, Col } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

function ContactAccessDetails({ contactDetails }) {
  const navigate = useNavigate();
  if (contactDetails?.systemUser?.username) {
    return (
      <Col span={20}>
        <Col span={24} className="flex">
          <p className="text-lg">Access Details</p>
        </Col>
        <Col span={24}>
          {contactDetails?.systemUser?.active && "System User access granted"}
        </Col>
        <Col span={24}>Username - {contactDetails?.systemUser?.username}</Col>
        <Col span={24}>
          <Button
            htmlType="button"
            onClick={() => {
              navigate(
                `/setup/contacts/update/${contactDetails?._id}/system-user/update`,
              );
            }}
          >
            {contactDetails?.systemUser ? "update" : "create"}
          </Button>
        </Col>
      </Col>
    );
  }
  return (
    <Col span={24} className="flex">
      <Button
        htmlType="button"
        onClick={() => {
          navigate(
            `/setup/contacts/update/${contactDetails?._id}/system-user/add`,
          );
        }}
      >
        Create System User
      </Button>
    </Col>
  );
}

export default ContactAccessDetails;
